import { CSSProperties, RefObject, memo } from 'react'

import { Item } from '@inno-sdks/files'
import { useIsTextTruncated } from '@inno-tools/react-hooks'
import { Tooltip, TooltipPlacements } from '@inno-ui/tooltip'
import cn from 'classnames'

import styles from './FolderViewItemName.module.scss'

export const FolderViewItemName = memo<{ item: Item }>(({ item }) => {
  const { isTruncated, textRef: nameRef } = useIsTextTruncated()

  return (
    <div className={styles.wrapper}>
      <Tooltip
        placement={TooltipPlacements.Bottom}
        disabled={!isTruncated}
        overlay={item.name}
        zIndex={2}
      >
        <p
          ref={nameRef as RefObject<HTMLParagraphElement>}
          className={cn(styles.name, 'itemName')}
          style={{ '--file-name-lines': 1 } as CSSProperties}
        >
          {item.name}
        </p>
      </Tooltip>
    </div>
  )
})
